"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityMetricsQueryTypeIterable = void 0;
exports.FacilityMetricsQueryTypeIterable = [
    'commitmentAmount',
    'unusedCommitment',
    'principalBalance',
    'interestRate',
    'receivableExposure',
    'receivableRepayment',
];
//# sourceMappingURL=Query.js.map